<p>
  my-photos-configuration works!
</p>
